"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilityCardSkeleton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var UtilityCardSkeleton = function () {
    return ((0, jsx_runtime_1.jsxs)(_1.Card, { children: [(0, jsx_runtime_1.jsx)(_1.CardHeader, { title: (0, jsx_runtime_1.jsx)(_1.Skeleton, {}) }), (0, jsx_runtime_1.jsx)(_1.CardContent, { children: (0, jsx_runtime_1.jsx)(_1.Skeleton, {}) })] }));
};
exports.UtilityCardSkeleton = UtilityCardSkeleton;
